<template>
  <div class="app-contract-holder">
    <ContractHolderFormModal
      :process="process"
      :current-customer.sync="changeCustomer"
      :invalid.sync="invalidPersonal"
      :show.sync="showContractHolderDataFormModal"
      @refresh="refreshContractHolderModal"
      @cancel="cancelContractHolderModal"
    >
      <template v-for="slot in possibleChildSlotsFor('ContractHolderFormModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ContractHolderFormModal>
    <SimonModal
      :is-visible="showContractHolderInfoModal"
      @hide="showContractHolderInfoModal = false"
      id="contract-holder-info-modal"
    >
      <slot name="contractHolderInfo"></slot>
    </SimonModal>
  <h2 class="h4"><slot name="contractHolderTitle">Vertragsinhaber/in beim aktuellen Anbieter</slot>&nbsp;<button @click="showContractHolderInfo" :aria-label="getSlotText('accessibilityInfoIconAlt')" class="icon-only"><img src="files/flash/images/svg-icons/info-icon.svg"></button></h2>
  <div class="inline-info-box card edit-card" v-if="contractHolder && !loading">
    <button type="button" @click="editContractHolder" :aria-label="getSlotText('accessibilityEditIconAlt')" class="icon-only-edit">
      <img src="/files/flash/images/svg-icons/pen.svg">
    </button>
    <div class="contract-data">
      <div class="label">
        <slot name="labelName">Vertragsinhaber/in</slot>
      </div>
      <div class="value">
        <span class="firstName">{{contractHolder.firstName}} </span>
        <span class="lastName">{{contractHolder.lastName}}</span>
      </div>
      <div class="label">
        <slot name="labelBirthDate">Geburtsdatum</slot>
      </div>
      <div class="value">
        {{contractHolder.birthDate}}
      </div>
    </div>
  </div>
  </div>
</template>
<script>

import cloneDeep from 'lodash.clonedeep'
import ContractHolderFormModal from '@/components/checkout/belatedPorting/ContractHolderFormModal.vue'
import transaction from '@/mixins/transaction'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ContractHolder',
  data () {
    return {
      showContractHolderInfoModal: false,
      showContractHolderDataFormModal: false,
      contractHolder: {
        gender: 'FEMALE',
        firstName: '',
        lastName: '',
        birthDate: ''
      },
      currentCustomer: {
        gender: 'FEMALE',
        firstName: '',
        lastName: '',
        birthDate: ''
      },
      changeCustomer: {
        gender: 'FEMALE',
        firstName: '',
        lastName: '',
        birthDate: ''
      },
      invalidPersonal: false,
      loading: true
    }
  },
  mixins: [
    transaction('contractHolder')
  ],
  components: { SimonModal, ContractHolderFormModal },
  props: {
    process: String
  },
  methods: {
    setContractHolder (contractHolder) {
      this.$store.commit(`checkoutv2/${this.process}/_mnpData/setContractHolder`, contractHolder)
    },
    editContractHolder () {
      this.showContractHolderDataFormModal = true
      const data = {
        information_action: 'submit',
        information_name: 'vertragsinhaber/in beim aktuellen anbieter',
        information_ui_type: 'layover',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    refreshContractHolderModal () {
      this.contractHolder = this.getContractHolder
      this.changeCustomer = cloneDeep(this.contractHolder)
    },
    cancelContractHolderModal () {
      this.prefillContractHolder(this.currentCustomer)
      this.changeCustomer = cloneDeep(this.contractHolder)
    },
    prefillContractHolder (newCustomer) {
      this.contractHolder = this.getContractHolder
      if (!this.contractHolder) {
        this.contractHolder = cloneDeep(newCustomer)
      }
      if (this.contractHolder.firstName === '' || this.contractHolder.lastName === '' || this.contractHolder.birthDate === '') {
        this.contractHolder = cloneDeep(newCustomer)
      }
      this.changeCustomer = cloneDeep(this.contractHolder)
      this.setContractHolder(this.contractHolder)
    },
    showContractHolderInfo () {
      this.showContractHolderInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'info vertragsinhaber/in beim aktuellen anbieter',
        information_ui_type: 'layover',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    }
  },
  computed: {
    getContractHolder () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/contractHolder`]
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            firstName,
            lastName,
            birthDate
          }
        }`, this, 'currentCustomer', {}, (data) => {
          this.loading = false
          this.prefillContractHolder(data)
        },
        { fetchPolicy: 'no-cache' },
        (error) => {
          splitError(error).forEach(e => { this.errorMsg = e.message })
          this.errorToast(this.errorMsg)
          this.loading = false
        }
      )
    }
  }
}
</script>
